import React, { ReactElement } from 'react';

export const LoadingGradientDefinition = (props: { id: string }): ReactElement => {
	return (
		<linearGradient id={props.id} x1="0" y1="0" x2="1" y2="0">
			<stop offset="0%" stopColor="#f0f0f0">
				<animate
					attributeName="stop-color"
					values="rgba(255, 255, 255, 0.3);rgba(255, 255, 255, 0.5);rgba(255, 255, 255, 0.3)"
					dur="2s"
					repeatCount="indefinite"
				/>
			</stop>
		</linearGradient>
	);
};
